/**
 * All possible Invoice status.
 */
export enum InvoiceStatus {
  OPEN = 'open',
  CLOSING = 'closing',
  CLOSED = 'closed',
  CANCELED = 'canceled'
}

/**
 * All possible Order status.
 */
export enum OrderStatus {
  OPEN = 'open',
  AUTHORIZED = 'authorized',
  STARTED = 'started',
  COMPLETED = 'completed',
  CANCELED = 'canceled'
}

/**
 * All possible Order consumption types.
 */
export enum OrderType {
  IN_LOCO,
  TAKEOUT_NOW,
  TAKEOUT_LATER,
  DELIVERY
}

/**
 * Accepted payment methods.
 */
export enum PaymentMethodEnum {
  CASH = 'cash',
  CREDIT_CARD = 'creditCard',
  DEBIT_CARD = 'debitCard',
  ONLINE = 'online'
}

/**
 * OrderPayment status.
 */
export enum OrderPaymentStatus {
  WAITING,
  COMPLETED,
  CANCELED
}

/**
 * Filazero payment methods.
 */
export enum FilazeroPaymentMethod {
  MONEY,
  CREDIT_CARD,
  DEBIT_CARD
}

/**
 * Menu Type
 **/
export enum MenuType {
  LITE,
  FULL
}
